import useInvoices from "../../../services/state/account/useInvoices";
import useValueChangeListener from "../../../services/state/general/useValueChangeListener";
import {range} from "../../../../res/dataServices/range";
import SkeletonDiv from "../../../../components/general/loading/SkeletonDiv";
import UnpaidInvoice from "./UpaidInvoice";

const UnpaidInvoiceList = () => {

    const { loading, invoices, getInvoices } = useInvoices();
    useValueChangeListener(() => {
        getInvoices({
            isPaid: false,
            pageSize: 1000,
            pageNo: 1,
            isSoTrx: false,
            docType: 1000005,
            includeOpenBalance: true
        })
    }, [""], [])

    return (
        <>
            {loading && range(5).map((i) => <SkeletonDiv key={i} style={{width: "600px", height: "20px", margin: "20px 0"}} />)}
            {(invoices && invoices.length > 0) && invoices.map((inv, i) =>
                <UnpaidInvoice invoice={inv} key={i} />
            )}
            {(!loading && invoices && invoices.length === 0) &&
                <p style={{textAlign: "left"}} className="page-h4">No unpaid invoices found. If this doesn't seem right, please get in contact with our team.</p>
            }
        </>
    )

}

export default UnpaidInvoiceList;